import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { QueryConfig } from '@/library/react-query';

export const getAllBlogs = (pageNumber: number, pageSize: number) => {
  return axios.get('/get-blogs', {
    params: {
      pageNumber,
      pageSize,
    },
  });
};

type UseGetBlogs = {
  config?: QueryConfig<typeof getAllBlogs>;
};

export const useGetBlogs = (
  pageNumber: number,
  pageSize: number,
  _params: UseGetBlogs = {}
) => {
  return useQuery({
    queryKey: ['get-blogs', { pageNumber, pageSize }],
    queryFn: () => {
      return getAllBlogs(pageNumber, pageSize);
    },
    enabled: !!pageNumber,
    useErrorBoundary: false,
  });
};
